export const offline_config =
  {
    "status":"ok",
      "errors":null,
      "redirect_to":null,
      "data":{
        "project":{
            "name":"GP IW Animation",
              "starting_stage":"entry",
              "current_status":"active"
        },
        "reporting":{
        },
        "social_media":{
            "facebook":{
                "app_id":"356461428446567",
                  "og_meta":{
                    "title":"LIM Demo GP IW Animation",
                      "description":"Enter for a chance at 2 tickets to Mexico!",
                      "img":"fb_meta_image.jpg"
                }
            }
        },
        "stages":[
            {
                "name":"before_start",
                "methods":{
                    "get":{
                        "active":false,
                        "url":null
                    },
                    "post":{
                        "active":true,
                        "url":"/api/v1/before-start"
                    }
                },
                "fields":{
                    "0":{
                        "name":"email",
                        "is_on":true,
                        "show":true,
                        "required":true,
                        "disabled":false,
                        "default":null
                    },
                    "2":{
                        "name":"email_optin",
                        "is_on":true,
                        "show":true,
                        "required":false,
                        "disabled":false,
                        "default":false
                    }
                }
            },
            {
                "name":"ended",
                "methods":{
                    "get":{
                        "active":false,
                        "url":null
                    },
                    "post":{
                        "active":true,
                        "url":"/api/v1/ended"
                    }
                },
                "fields":{
                    "0":{
                        "name":"email",
                        "is_on":true,
                        "show":true,
                        "required":true,
                        "disabled":false,
                        "default":null
                    },
                    "2":{
                        "name":"email_optin",
                        "is_on":true,
                        "show":true,
                        "required":false,
                        "disabled":false,
                        "default":false
                    }
                }
            },
            {
                "name":"gate",
                "methods":{
                    "get":{
                        "active":false,
                        "url":null
                    },
                    "post":{
                        "active":true,
                        "url":"/api/v1/gate"
                    }
                },
                "fields":{
                    "1":{
                        "name":"date_of_birth",
                        "is_on":true,
                        "show":true,
                        "required":true,
                        "disabled":false,
                        "default":null
                    },
                    "2":{
                        "name":"state",
                        "is_on":true,
                        "show":true,
                        "required":true,
                        "disabled":false,
                        "choices":{
                            "AK":"Alaska",
                            "AL":"Alabama",
                            "AR":"Arkansas",
                            "AZ":"Arizona",
                            "CA":"California",
                            "CO":"Colorado",
                            "CT":"Connecticut",
                            "DC":"District of Columbia",
                            "DE":"Delaware",
                            "FL":"Florida",
                            "GA":"Georgia",
                            "HI":"Hawaii",
                            "IA":"Iowa",
                            "ID":"Idaho",
                            "IL":"Illinois",
                            "IN":"Indiana",
                            "KS":"Kansas",
                            "KY":"Kentucky",
                            "LA":"Louisiana",
                            "MA":"Massachusetts",
                            "MD":"Maryland",
                            "ME":"Maine",
                            "MI":"Michigan",
                            "MN":"Minnesota",
                            "MO":"Missouri",
                            "MS":"Mississippi",
                            "MT":"Montana",
                            "NC":"North Carolina",
                            "ND":"North Dakota",
                            "NE":"Nebraska",
                            "NH":"New Hampshire",
                            "NJ":"New Jersey",
                            "NM":"New Mexico",
                            "NV":"Nevada",
                            "NY":"New York",
                            "OH":"Ohio",
                            "OK":"Oklahoma",
                            "OR":"Oregon",
                            "PA":"Pennsylvania",
                            "RI":"Rhode Island",
                            "SC":"South Carolina",
                            "SD":"South Dakota",
                            "TN":"Tennessee",
                            "TX":"Texas",
                            "UT":"Utah",
                            "VA":"Virginia",
                            "VT":"Vermont",
                            "WA":"Washington",
                            "WI":"Wisconsin",
                            "WV":"West Virginia",
                            "WY":"Wyoming"
                        },
                        "default":null
                    }
                }
            },
            {
                "name":"entry",
                "methods":{
                    "get":{
                        "active":false,
                        "url":null
                    },
                    "post":{
                        "active":true,
                        "url":"/api/v1/entry"
                    }
                },
                "fields":{
                    "4":{
                        "name":"phone",
                        "is_on":true,
                        "show":true,
                        "required":true,
                        "disabled":false,
                        "default":null
                    },
                    "3":{
                        "name":"email",
                        "is_on":true,
                        "show":true,
                        "required":true,
                        "disabled":false,
                        "default":'dddddddd@lim.bz'
                    },
                    "5":{
                        "name":"date_of_birth",
                        "is_on":true,
                        "show":true,
                        "required":true,
                        "disabled":false,
                        "default":null
                    },
                    "7":{
                        "name":"tc_accepted",
                        "is_on":true,
                        "show":true,
                        "required":true,
                        "disabled":false,
                        "default":true
                    },
                    "9":{
                        "name":"email_optin",
                        "is_on":true,
                        "show":true,
                        "required":false,
                        "disabled":false,
                        "default":false
                    },
                    "15":{
                        "name":"state",
                        "is_on":true,
                        "show":true,
                        "required":true,
                        "disabled":false,
                        "choices":{
                            "AK":"Alaska",
                            "AL":"Alabama",
                            "AR":"Arkansas",
                            "AZ":"Arizona",
                            "CA":"California",
                            "CO":"Colorado",
                            "CT":"Connecticut",
                            "DC":"District of Columbia",
                            "DE":"Delaware",
                            "FL":"Florida",
                            "GA":"Georgia",
                            "HI":"Hawaii",
                            "IA":"Iowa",
                            "ID":"Idaho",
                            "IL":"Illinois",
                            "IN":"Indiana",
                            "KS":"Kansas",
                            "KY":"Kentucky",
                            "LA":"Louisiana",
                            "MA":"Massachusetts",
                            "MD":"Maryland",
                            "ME":"Maine",
                            "MI":"Michigan",
                            "MN":"Minnesota",
                            "MO":"Missouri",
                            "MS":"Mississippi",
                            "MT":"Montana",
                            "NC":"North Carolina",
                            "ND":"North Dakota",
                            "NE":"Nebraska",
                            "NH":"New Hampshire",
                            "NJ":"New Jersey",
                            "NM":"New Mexico",
                            "NV":"Nevada",
                            "NY":"New York",
                            "OH":"Ohio",
                            "OK":"Oklahoma",
                            "OR":"Oregon",
                            "PA":"Pennsylvania",
                            "RI":"Rhode Island",
                            "SC":"South Carolina",
                            "SD":"South Dakota",
                            "TN":"Tennessee",
                            "TX":"Texas",
                            "UT":"Utah",
                            "VA":"Virginia",
                            "VT":"Vermont",
                            "WA":"Washington",
                            "WI":"Wisconsin",
                            "WV":"West Virginia",
                            "WY":"Wyoming"
                        },
                        "default":'AK'
                    }
                }
            },
            {
                "name":"sweepstakes_selection",
                "methods":{
                    "get":{
                        "active":true,
                        "url":"/api/v1/sweepstakes/selection"
                    },
                    "post":{
                        "active":true,
                        "url":"/api/v1/sweepstakes/selection"
                    }
                },
                "fields":[
                    {
                        "name":"selected_pool_id",
                        "is_on":true,
                        "show":false,
                        "required":true,
                        "disabled":false,
                        "default":null
                    }
                ]
            },
            {
                "name":"game_play_regular",
                "game_type":"animation",
                "methods":{
                    "get":{
                        "active":true,
                        "url":"/api/v1/instant-win/take-chance"
                    },
                    "post":{
                        "active":false,
                        "url":null
                    }
                },
                "fields":{
                }
            },
            {
                "name":"instant_win_approval",
                "methods":{
                    "get":{
                        "active":true,
                        "url":"/api/v1/instant-win/approval"
                    },
                    "post":{
                        "active":true,
                        "url":"/api/v1/instant-win/approval"
                    }
                },
                "fields":[
                    {
                        "name":"choice",
                        "is_on":true,
                        "show":true,
                        "required":true,
                        "disabled":false,
                        "default":null
                    },
                    {
                        "name":"reward_reservation_uid",
                        "is_on":true,
                        "show":false,
                        "required":true,
                        "disabled":false,
                        "default":null
                    }
                ]
            },
            {
                "name":"success",
                "methods":{
                    "get":{
                        "active":true,
                        "url":"/api/v1/success"
                    },
                    "post":{
                        "active":false,
                        "url":"/api/v1/success"
                    }
                },
                "fields":{
                }
            },
            {
                "name":"failed",
                "methods":{
                    "get":{
                        "active":true,
                        "url":"/api/v1/failed"
                    },
                    "post":{
                        "active":false,
                        "url":"/api/v1/failed"
                    }
                },
                "fields":{
                }
            },
            {
                "name":"winner_form",
                "methods":{
                    "get":{
                        "active":true,
                        "url":"/api/v1/winner-form"
                    },
                    "post":{
                        "active":true,
                        "url":"/api/v1/winner-form"
                    }
                },
                "fields":{
                    "0":{
                        "name":"first_name",
                        "is_on":true,
                        "show":true,
                        "required":true,
                        "disabled":false,
                        "default":'John'
                    },
                    "1":{
                        "name":"last_name",
                        "is_on":true,
                        "show":true,
                        "required":true,
                        "disabled":false,
                        "default":null
                    },
                    "2":{
                        "name":"email",
                        "is_on":true,
                        "show":true,
                        "required":true,
                        "disabled":true,
                        "default":null
                    },
                    "3":{
                        "name":"phone",
                        "is_on":true,
                        "show":true,
                        "required":true,
                        "disabled":false,
                        "default":null
                    },
                    "4":{
                        "name":"address1",
                        "is_on":true,
                        "show":true,
                        "required":true,
                        "disabled":false,
                        "default":null
                    },
                    "5":{
                        "name":"address2",
                        "is_on":true,
                        "show":true,
                        "required":false,
                        "disabled":false,
                        "default":null
                    },
                    "6":{
                        "name":"city",
                        "is_on":true,
                        "show":true,
                        "required":true,
                        "disabled":false,
                        "default":null
                    },
                    "7":{
                        "name":"zipcode",
                        "is_on":true,
                        "show":true,
                        "required":true,
                        "disabled":false,
                        "default":null
                    },
                    "8":{
                        "name":"state",
                        "is_on":true,
                        "show":true,
                        "required":true,
                        "disabled":false,
                        "choices":{
                            "AK":"Alaska",
                            "AL":"Alabama",
                            "AR":"Arkansas",
                            "AZ":"Arizona",
                            "CA":"California",
                            "CO":"Colorado",
                            "CT":"Connecticut",
                            "DC":"District of Columbia",
                            "DE":"Delaware",
                            "FL":"Florida",
                            "GA":"Georgia",
                            "HI":"Hawaii",
                            "IA":"Iowa",
                            "ID":"Idaho",
                            "IL":"Illinois",
                            "IN":"Indiana",
                            "KS":"Kansas",
                            "KY":"Kentucky",
                            "LA":"Louisiana",
                            "MA":"Massachusetts",
                            "MD":"Maryland",
                            "ME":"Maine",
                            "MI":"Michigan",
                            "MN":"Minnesota",
                            "MO":"Missouri",
                            "MS":"Mississippi",
                            "MT":"Montana",
                            "NC":"North Carolina",
                            "ND":"North Dakota",
                            "NE":"Nebraska",
                            "NH":"New Hampshire",
                            "NJ":"New Jersey",
                            "NM":"New Mexico",
                            "NV":"Nevada",
                            "NY":"New York",
                            "OH":"Ohio",
                            "OK":"Oklahoma",
                            "OR":"Oregon",
                            "PA":"Pennsylvania",
                            "RI":"Rhode Island",
                            "SC":"South Carolina",
                            "SD":"South Dakota",
                            "TN":"Tennessee",
                            "TX":"Texas",
                            "UT":"Utah",
                            "VA":"Virginia",
                            "VT":"Vermont",
                            "WA":"Washington",
                            "WI":"Wisconsin",
                            "WV":"West Virginia",
                            "WY":"Wyoming"
                        },
                        "default":null
                    },
                    "10":{
                        "name":"reward_reservation_uid",
                        "is_on":true,
                        "show":false,
                        "required":true,
                        "disabled":false,
                        "default":null
                    }
                }
            },
            {
                "name":"doe_form",
                "methods":{
                    "get":{
                        "active":true,
                        "url":"/api/v1/doe-form"
                    },
                    "post":{
                        "active":true,
                        "url":"/api/v1/doe-form"
                    }
                },
                "fields":[
                    {
                        "name":"date_of_birth",
                        "is_on":true,
                        "show":true,
                        "required":true,
                        "disabled":false,
                        "default":null
                    },
                    {
                        "name":"phone_daytime",
                        "is_on":true,
                        "show":true,
                        "required":false,
                        "disabled":false,
                        "default":null
                    },
                    {
                        "name":"phone_evening",
                        "is_on":true,
                        "show":true,
                        "required":false,
                        "disabled":false,
                        "default":null
                    },
                    {
                        "name":"is_confirmed",
                        "is_on":true,
                        "show":true,
                        "required":true,
                        "disabled":false,
                        "default":false
                    },
                    {
                        "name":"reward_reservation_uid",
                        "is_on":true,
                        "show":false,
                        "required":true,
                        "disabled":false,
                        "default":null
                    }
                ]
            },
            {
                "name":"download_page",
                "methods":{
                    "get":{
                        "active":true,
                        "url":"/api/v1/download-forms"
                    },
                    "post":{
                        "active":false,
                        "url":null
                    }
                },
                "fields":[
                    {
                        "name":"reward_reservation_uid",
                        "is_on":true,
                        "show":false,
                        "required":true,
                        "disabled":false,
                        "default":null
                    }
                ]
            },
            {
                "name":"facebook_share",
                "methods":{
                    "get":{
                        "active":false,
                        "url":null
                    },
                    "post":{
                        "active":true,
                        "url":"/api/v1/share/facebook"
                    }
                },
                "fields":[
                    {
                        "name":"share",
                        "is_on":true,
                        "show":true,
                        "required":false,
                        "disabled":false,
                        "default":null,
                        "bonus":false
                    }
                ]
            },
            {
                "name":"twitter_share",
                "methods":{
                    "get":{
                        "active":false,
                        "url":null
                    },
                    "post":{
                        "active":true,
                        "url":"/api/v1/share/twitter"
                    }
                },
                "fields":[
                    {
                        "name":"share",
                        "is_on":true,
                        "show":true,
                        "required":false,
                        "disabled":false,
                        "default":null,
                        "bonus":false
                    }
                ]
            },
            {
                "name":"fulfillment",
                "methods":{
                    "get":{
                        "active":true,
                        "url":"/api/v1/fulfillment"
                    },
                    "post":{
                        "active":false,
                        "url":null
                    }
                },
                "fields":[
                    {
                        "name":"reward_reservation_uid",
                        "is_on":true,
                        "show":false,
                        "required":true,
                        "disabled":false,
                        "default":null
                    },
                    {
                        "name":"choice",
                        "is_on":true,
                        "show":false,
                        "required":false,
                        "disabled":false,
                        "default":null,
                        "choices":{
                            "acceptance":"accepted",
                            "rejection":"rejected"
                        }
                    }
                ]
            },
            {
                "name":"fulfillment_reward_acceptance",
                "methods":{
                    "get":{
                        "active":true,
                        "url":"/api/v1/fulfillment/reward-acceptance"
                    },
                    "post":{
                        "active":true,
                        "url":"/api/v1/fulfillment/reward-acceptance"
                    }
                },
                "fields":[
                    {
                        "name":"reward_reservation_uid",
                        "is_on":true,
                        "show":false,
                        "required":true,
                        "disabled":false,
                        "default":null
                    },
                    {
                        "name":"choice",
                        "is_on":true,
                        "show":false,
                        "required":true,
                        "disabled":false,
                        "default":null,
                        "choices":{
                            "acceptance":"accepted",
                            "rejection":"rejected"
                        }
                    }
                ]
            },
            {
                "name":"fulfillment_winner_form",
                "methods":{
                    "get":{
                        "active":true,
                        "url":"/api/v1/fulfillment/winner-form"
                    },
                    "post":{
                        "active":true,
                        "url":"/api/v1/fulfillment/winner-form"
                    }
                },
                "fields":{
                    "0":{
                        "name":"first_name",
                        "is_on":true,
                        "show":true,
                        "required":true,
                        "disabled":false,
                        "default":null
                    },
                    "1":{
                        "name":"last_name",
                        "is_on":true,
                        "show":true,
                        "required":true,
                        "disabled":false,
                        "default":null
                    },
                    "2":{
                        "name":"email",
                        "is_on":true,
                        "show":true,
                        "required":true,
                        "disabled":true,
                        "default":null
                    },
                    "3":{
                        "name":"phone",
                        "is_on":true,
                        "show":true,
                        "required":true,
                        "disabled":false,
                        "default":null
                    },
                    "4":{
                        "name":"address1",
                        "is_on":true,
                        "show":true,
                        "required":true,
                        "disabled":false,
                        "default":null
                    },
                    "5":{
                        "name":"address2",
                        "is_on":true,
                        "show":true,
                        "required":false,
                        "disabled":false,
                        "default":null
                    },
                    "6":{
                        "name":"city",
                        "is_on":true,
                        "show":true,
                        "required":true,
                        "disabled":false,
                        "default":null
                    },
                    "7":{
                        "name":"zipcode",
                        "is_on":true,
                        "show":true,
                        "required":true,
                        "disabled":false,
                        "default":null
                    },
                    "8":{
                        "name":"state",
                        "is_on":true,
                        "show":true,
                        "required":true,
                        "disabled":false,
                        "choices":{
                            "AK":"Alaska",
                            "AL":"Alabama",
                            "AR":"Arkansas",
                            "AZ":"Arizona",
                            "CA":"California",
                            "CO":"Colorado",
                            "CT":"Connecticut",
                            "DC":"District of Columbia",
                            "DE":"Delaware",
                            "FL":"Florida",
                            "GA":"Georgia",
                            "HI":"Hawaii",
                            "IA":"Iowa",
                            "ID":"Idaho",
                            "IL":"Illinois",
                            "IN":"Indiana",
                            "KS":"Kansas",
                            "KY":"Kentucky",
                            "LA":"Louisiana",
                            "MA":"Massachusetts",
                            "MD":"Maryland",
                            "ME":"Maine",
                            "MI":"Michigan",
                            "MN":"Minnesota",
                            "MO":"Missouri",
                            "MS":"Mississippi",
                            "MT":"Montana",
                            "NC":"North Carolina",
                            "ND":"North Dakota",
                            "NE":"Nebraska",
                            "NH":"New Hampshire",
                            "NJ":"New Jersey",
                            "NM":"New Mexico",
                            "NV":"Nevada",
                            "NY":"New York",
                            "OH":"Ohio",
                            "OK":"Oklahoma",
                            "OR":"Oregon",
                            "PA":"Pennsylvania",
                            "RI":"Rhode Island",
                            "SC":"South Carolina",
                            "SD":"South Dakota",
                            "TN":"Tennessee",
                            "TX":"Texas",
                            "UT":"Utah",
                            "VA":"Virginia",
                            "VT":"Vermont",
                            "WA":"Washington",
                            "WI":"Wisconsin",
                            "WV":"West Virginia",
                            "WY":"Wyoming"
                        },
                        "default":null
                    },
                    "10":{
                        "name":"reward_reservation_uid",
                        "is_on":true,
                        "show":false,
                        "required":true,
                        "disabled":false,
                        "default":null
                    }
                }
            },
            {
                "name":"fulfillment_doe_form",
                "methods":{
                    "get":{
                        "active":true,
                        "url":"/api/v1/fulfillment/doe-form"
                    },
                    "post":{
                        "active":true,
                        "url":"/api/v1/fulfillment/doe-form"
                    }
                },
                "fields":[
                    {
                        "name":"date_of_birth",
                        "is_on":true,
                        "show":true,
                        "required":true,
                        "disabled":false,
                        "default":null
                    },
                    {
                        "name":"phone_daytime",
                        "is_on":true,
                        "show":true,
                        "required":false,
                        "disabled":false,
                        "default":null
                    },
                    {
                        "name":"phone_evening",
                        "is_on":true,
                        "show":true,
                        "required":false,
                        "disabled":false,
                        "default":null
                    },
                    {
                        "name":"is_confirmed",
                        "is_on":true,
                        "show":true,
                        "required":true,
                        "disabled":false,
                        "default":false
                    },
                    {
                        "name":"reward_reservation_uid",
                        "is_on":true,
                        "show":false,
                        "required":true,
                        "disabled":false,
                        "default":null
                    }
                ]
            },
            {
                "name":"fulfillment_upload_page",
                "methods":{
                    "get":{
                        "active":true,
                        "url":"/api/v1/fulfillment/upload-forms"
                    },
                    "post":{
                        "active":true,
                        "url":"/api/v1/fulfillment/upload-forms"
                    }
                },
                "fields":[
                    {
                        "name":"reward_reservation_uid",
                        "is_on":true,
                        "show":false,
                        "required":true,
                        "disabled":false,
                        "default":null
                    },
                    {
                        "name":"w9_file",
                        "is_on":true,
                        "show":true,
                        "required":true,
                        "disabled":false,
                        "default":null
                    },
                    {
                        "name":"affidavit_file",
                        "is_on":true,
                        "show":true,
                        "required":true,
                        "disabled":false,
                        "default":null
                    }
                ]
            }
        ]
    }
}

